module.exports = "\n<mat-progress-bar *ngIf=\"isRouting\"  mode=\"indeterminate\"></mat-progress-bar>\n<router-outlet></router-outlet>\n"